













import Vue, {PropType} from 'vue';

export default Vue.extend({
    name: 'favorite-star',
    props: {
        value: {
            type: Boolean as PropType<boolean | undefined>,
            required: false,
        },
    },
});
